import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function TermsOfUse() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <main
        style={{
          flex: '1',
          maxWidth: '900px',
          margin: '0 auto',
          padding: '2rem',
          fontFamily: 'Arial, sans-serif',
          lineHeight: '1.8',
          color: '#333'
        }}
      >
        <h1 style={{ textAlign: 'center', marginBottom: '2rem', fontSize: '2.5rem', fontWeight: 'bold' }}>
          Terms of Use
        </h1>
        <p>
          The Honor Society Tutors, Inc�(HST) HonorSocietyTutors.com platform (referred to as HST) allows tutors to reach students. 
	  HST does not make any money from these introductions and is not responsible for the actions of the tutors or students 
	  during these interactions. You understand and agree that HST is not party to any agreements entered into between users and HST tutors are not 
	  employees or even contractors of HST. HST has no control over the conduct of users, tutors and other users of the site 
	  and services, and disclaims all liability in this regard.
	</p>

	<p>
	  HST does not endorse any tutor and you are responsible for determining and confirming the identity and suitability 
	  of the tutor you interacted with as a result of your use. The Parties are encouraged to do their own due diligence in 
	  verifying identities utilizing reputable background check means and providers. By using the site or services, 
	  you, and any third party that may use the Site and Services agree (i) any legal remedy or liability that you or such 
	  third party seek to obtain for actions or omissions of HST, Users or other third parties will be limited to a claim against 
	  the particular Tutor, User or the third parties who caused you, or such third party harm; and (ii) not to attempt to 
	  impose liability on, or seek any legal remedy from HST with respect to such actions or omissions. In addition, 
	  HST is not responsible for the use or exchange of any information or files between Tutors and Users.
	</p>

	<p>
	  HST tutors who elect to utilize the HST website tutoring pages to promote their tutoring services do so with 
 	  the understanding that HST does not vet prospective tutoring clients (parents/guardians and students). Those 
	  who use the tutoring services do so with the understanding that HST does not supervise tutors providing the services 
	  and the tutors listed are not employees of HST. All parties utilizing the tutoring pages do so with the understanding 
	  that HST provides them as a means of connecting parents and guardians who want to provide additional help for 
	  their students with tutors who indicate ability in a particular discipline. 
	</p>

	<p>
	  You acknowledge and agree that, by accessing or using the site or services, searching for a tutor via HST, or by 
	  posting any content on the site or through the services, you are indicating that you have read, and that you understand 
	  and agree to be bound by these user terms of service whether or not you have registered via the site. If you do not agree 
	  to these user terms of service, then you have no right to access or use the site, service or content.
	</p>

	<p>
	  Students and tutors agree at all times to comply with the Code of Conduct (or similarly-named set of norms) at 
	  your respective school, and all other applicable laws. Under no circumstances will plagiarism or other acts of dishonesty 
	  be condoned. You agree that all information you provide to HST or put on the platform will be accurate and truthful. You 
	  agree that you may be removed from HST for any violation of the Code of Conduct or applicable laws. 
	</p>

	<p>
	  Disclaimers
	</p>

	<p>
	  HST is not responsible for disputes, claims, loss, injury or damage of any kind that might arise during and after tutoring 
	  sessions. We reserve the right, but have no obligation, to monitor interactions and disputes between users and tutors.
	  </p>

	  <p>
	  This site is provided on an�'as is' basis and HST disclaims all responsibility for any loss, liability, injury, claim, or 
	  damage of any kind resulting from any errors in the site and its content including, but not limited to, typographical 
	  and technical errors and inaccuracies. 
	</p>

	<p>
	  HST does not warrant that the site and services will meet your requirements, or that the operation of the site and services
	   will be uninterrupted or error-free, or that defects in the site and services will be corrected.
	</p>

	<p>
	  You acknowledge and agree that HST does not have an obligation to conduct reference checks on or to interview or 
	  screen any user of the site, including, but not limited to tutors. You are solely responsible for all of your communications 
	  and interactions with tutors and other users of the site and services and with other persons with whom you communicate or 
	  interact as a result of your use of the site or services, including, without limitation, any interaction with Tutors or users 
	  via the services or otherwise.
	</p>

	<p>
	  Indemnity
	</p>

	<p>
	  You agree to indemnify and hold HST and its representatives harmless from any claim or demand, including 
	  reasonable attorneys' fees, made by any third party due to or arising out of your use of or connection to HST (including 
	  any use by you or behalf of another party), your violation of the User Terms of Service, of your violation of any rights or another.
	</p>

	<p>
	  Limitation of Liability
	</p>

	<p>
	  To the full extent permitted by law, peertutors.com is not liable for any direct, indirect, punitive, special, incidental, 
	  consequential, or exemplary damages (including, without limitation, loss of business, revenue, profits, goodwill, use, 
 	  data, electronically transmitted orders, or other economic advantage) arising out of or in connection with the site, even 
	  if HST has previously been advised of, or reasonably could have foreseen, the possibility of such damages, however 
	  they arise, whether in breach of contract or in tort (including negligence), including without limitation damages due to: 
	  the use of or the inability to use the site; the cost or procurement of substitute goods and services resulting from any 
	  goods, data, information, or services purchased or obtained, or messages received or transactions entered into, 
	  through or from the site; statements or conduct of any third party on the site, including without limitation unauthorized access 
	  to or alteration of transmission or data, malicious or criminal behavior, or false or fraudulent transactions; or content or 
	  information you may download, use, modify, or distribute.
	</p>

	<p>
          Continued use of the site indicates acceptance of these terms. The site is owned and operated by Honor Society Tutors, Inc. 
        </p>
      </main>
    </div>
  );
}
